import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AcceptCookieToWatch, WatchVideoNotAllowed } from 'autogen/translation-keys/trans-website-shared';
import CookieInfobox from 'components/CookieInfobox';
import useHasInformationCookieBeenAccepted from 'hooks/user/useHasInformationCookieBeenAccepted';
import { CookieCategory } from 'modules/helpers/cookieInformationHelper';

const CookieOverlay = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
`;

export default function VideoCookieOverlay() {
    const { t } = useTranslation();
    const isFunctionalCookieAccepted = useHasInformationCookieBeenAccepted(CookieCategory.functional);

    if (isFunctionalCookieAccepted) return null;

    return (
        <CookieOverlay>
            <CookieInfobox headline={t(WatchVideoNotAllowed)} body={t(AcceptCookieToWatch)} />
        </CookieOverlay>
    );
}
